document.addEventListener("DOMContentLoaded", function () {
  var questions = document.querySelectorAll(
    ".nested-accordion-container .nested-accordion-item .ac-header .ac-trigger"
  );
  var answers = document.querySelectorAll(
    ".nested-accordion-container .nested-accordion-item .ac-panel"
  );

  function generateFAQSchema() {
    var faqItems = [];

    for (var i = 0; i < questions.length; i++) {
      var questionText = questions[i].innerHTML.trim();

      var answerP = Array.from(answers[i].querySelectorAll("p"))
        .map((p) => p.textContent.replace(/\s+/g, " ").trim())
        .join(" ");
      var answerLi = Array.from(answers[i].querySelectorAll("ul li"))
        .map((p) => p.textContent.replace(/\s+/g, " ").trim())
        .join(" ");

      var answerText = answerP + " " + answerLi;

      faqItems.push({
        "@type": "Question",
        name: questionText,
        acceptedAnswer: {
          "@type": "Answer",
          text: answerText,
        },
      });
    }

    var faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems,
    };

    return JSON.stringify(faqSchema);
  }

  function injectFAQSchema() {
    var faqSchemaString = generateFAQSchema();
    var script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = faqSchemaString;
    document.head.appendChild(script);
  }
  if (questions || answers) {
    injectFAQSchema();
  }
});
